import BeforeAfter from "./BeforeAfter";

/**
 * Interactive "Before/After" sliders stacked vertically with alternating offset.
 * Each pair renders as a single draggable slider (BeforeAfter component).
 */
export default function BeforeAfterStack({ items = [] }) {
    if (!items.length) return null;
    return (
        <div className="space-y-10 sm:space-y-14" data-testid="before-after-stack">
            {items.map((it, idx) => (
                <div
                    key={`ba-${it.before || idx}-${it.after || idx}`}
                    className={`
                        transition
                        ${idx % 2 === 0 ? "sm:ml-0 sm:mr-8" : "sm:ml-8 sm:mr-0 sm:mt-2"}
                    `}
                    style={{ transform: `translateY(${idx * 12}px)` }}
                    data-testid={`ba-pair-${idx}`}
                >
                    <div className="mb-4 flex flex-wrap items-baseline justify-between gap-2">
                        <div>
                            <div className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--copper))] mb-1">
                                {String(idx + 1).padStart(2, "0")}
                            </div>
                            <h3 className="font-display font-bold text-xl sm:text-2xl">{it.title}</h3>
                            {it.subtitle && (
                                <p className="text-sm text-[hsl(var(--graphite))]/60">{it.subtitle}</p>
                            )}
                        </div>
                    </div>

                    <div className="rounded-2xl overflow-hidden">
                        <BeforeAfter before={it.before} after={it.after} alt={it.title} />
                    </div>
                </div>
            ))}
        </div>
    );
}
